import { render, staticRenderFns } from "./company_create.vue?vue&type=template&id=2c6883d1"
import script from "./company_create.vue?vue&type=script&lang=js"
export * from "./company_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports